module.exports = __webpack_public_path__ + "static/media/c54d9da9.jpg";